import { deleteAssetsActionTrackerState } from './actionTracker';

export const state = {
  deleteAssetsTracker: deleteAssetsActionTrackerState,
};
